// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-error[data-v-92d99320] {\n  border: 1px solid red;\n}\n.error-text[data-v-92d99320] {\n  color: red;\n  font-size: 12px;\n  margin-left: 5px;\n}", ""]);
// Exports
module.exports = exports;
